import { render, staticRenderFns } from "./ShuttleList.vue?vue&type=template&id=1409cb01&scoped=true"
import script from "./ShuttleList.vue?vue&type=script&lang=js"
export * from "./ShuttleList.vue?vue&type=script&lang=js"
import style0 from "./ShuttleList.vue?vue&type=style&index=0&id=1409cb01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1409cb01",
  null
  
)

export default component.exports